import React from 'react'

export const htmlTags = {
  p: (...chunks) => <p>{chunks}</p>,
  code: (...chunks) => <code>{chunks}</code>,
  pre: (...chunks) => <pre>{chunks}</pre>,
  strong: (...chunks) => <strong>{chunks}</strong>,
  span: (...chunks) => <span>{chunks}</span>,
  em: (...chunks) => <em>{chunks}</em>,
  ul: (...chunks) => <ul>{chunks}</ul>,
  li: (...chunks) => <li>{chunks}</li>,
  hr: <hr />,
  v: (...chunks) => {
    return '${' + chunks + '}'
  },
}

export const FormattedMessage = ({
  id,
  values = {},
  autop = false,
  html = false,
  ...rest
}) => {
  const msg = intl.formatMessage({ id, ...rest }, values)

  if (autop) {
    return (
      <>
        {msg.split('\n').map((line, k) => (
          <p key={k}>{line}</p>
        ))}
      </>
    )
  }

  return <>{msg}</>
}
